/** Client-only parent marker added to subordinate report rows. */
export const REPORT_MASTER_ROW_ID = '__reportMasterRowId';
